import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import { FormattedMessage } from 'react-intl';

export class ChartResource extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      report: [],
      loading: true,
      date: curDate,
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
  }

  componentDidMount() {
    this.populateCompaniesData();
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateMonthData(ownCompanies[0].id, this.state.date);
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  prevMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() - 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  nextMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() + 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  renderReportTable() {
    var date = this.state.date;
    return (
      <div>

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th width="16px" onClick={() => this.prevMonth()}>&lt;</th>
            <th><FormattedMessage id="resource"/></th>
            <th>{date.toLocaleString(undefined, {month: '2-digit', year: 'numeric'})}</th>
            <th width="16px" onClick={() => this.nextMonth()}>&gt;</th>
          </tr>
        </thead>
        <tbody>
          {this.state.report.map(user =>
            <tr key={user.day}>
              <td></td>
              <td>{user.name}</td>
              <td>{user.value}</td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>

      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderReportTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="charts" />
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="resource_chart_page"/></h4></div>
        {contents}
      </div>
    );
  }

  async populateMonthData(companyId, month) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/report/${companyId}/resourcereport?month=${month.toLocaleDateString('en-US')}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, report: data, loading: false}));
  }
}
